import { render, staticRenderFns } from "./TerminateCamundaProcess.vue?vue&type=template&id=2973cc60&"
import script from "./TerminateCamundaProcess.vue?vue&type=script&lang=js&"
export * from "./TerminateCamundaProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports